window.QuickSoft = (function(ns) 
{
    if (!ns.Signer) ns.Signer = { }; 
    var signerNS = ns.Signer;

    signerNS.UI = {
        ViewServices: require("./viewservices"),
        ViewController: require("./viewcontroller")
    };

    return ns;
})(window.QuickSoft || {});


// WEBPACK FOOTER //
// ./C:/Projetos_Git/qframework_client/src/gui_js/lib/index.js